import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import payoutDetailsActions from '../actions/payoutDetails';
import {isNetNewIPM} from '../utils/validate';

function submitPayoutDetailsForm(store, action) {
    request.post(`/${config.url_prefix}/api/submitPayoutDetails`)
        .send({
            data: action.payload
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(payoutDetailsActions.alertError('ipmob.internal.server.error'));
            } else if (response.statusCode === 204) {
                const userType = store.getState().app.userType;

                if (isNetNewIPM(userType)) {
                    store.dispatch(actions.changeAppState('MAILING_INFORMATION'));
                } else {
                    store.dispatch(actions.changeAppState('LISTING_MODEL'));
                }
            } else {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(payoutDetailsActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default submitPayoutDetailsForm;
